import * as yup from 'yup';
import docs from './attachments';
import {
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenal,
  consentimentoDescontoFolha,
  medicos,
  consentimentoDadosSensiveis,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAjustePagamento,
  // declaracaoTipoRegime,
  // tipoRegime,
  // aceite,
} from './utils/rulesByKey';

export const MAISchema = yup.object({
  ...medicos('medicoPerito'),
  ...medicos('medicoAssistente'),
  ...adiantamentoQuinzenal,
  ...acessoContraCheque,
  // ...acessoJornalForluz,
  ...consentimentoDescontoFolha,
  ...consentimentoAjustePagamento,
  ...consentimentoDadosSensiveis(),
  ...declaracaoVeracidade,
  ...docs.MAIDocs.rules,
  ...aceiteInss,
  // ...declaracaoTipoRegime,
  // ...tipoRegime,
  // ...aceite,
});

export const MAIInitialValues = {
  medicoPerito: '',
  medicoAssistente: '',
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDescontoFolha: false,
  opcaoBeneficio: '',
  prazo: '',
  percentualRetiradaMensal: '',
  consentimentoDadosSensiveis: false,
  declaracaoVeracidade: false,
  consentimentoAjustePagamento: false,
  aceiteInss: false,
  // tipoRegime: '',
  // declaracaoTipoRegime: false,
  // aceite: false,
  ...docs.MAIDocs.initialValues,
  ...docs.molestiaGraveDocs.initialValues,
};

export const MAIDocs = {
  ...docs.MAIDocs.docs,
};
